import { formatCategories } from "components/Catalog/TableFilters/utils/formatCategories";
import { formatPrice } from "utils/formatPrice";
import { ProductsFiltersValuesType } from "app/types";
import dayjs from "dayjs";

export const formatFiltersForTags = (
  filtersObj: ProductsFiltersValuesType,
  minPrice: number,
  maxPrice: number,
  date: [dayjs.Dayjs, dayjs.Dayjs]
) => {
  const cleanObject: ProductsFiltersValuesType = Object.fromEntries(
    Object.entries(filtersObj).filter(([_, value]) => value !== undefined)
  );

  const supplierCategories: Record<string, string> = formatCategories(
    "supplierCategory",
    cleanObject?.supplierCategory
  ) ?? {};
  const categoriesBK: Record<string, string> = formatCategories("categoryBK", cleanObject?.categoryBK) ?? {};
  const needAddPrice: boolean = filtersObj.price?.[0] !== minPrice || filtersObj.price?.[1] !== maxPrice;

  const getPrice = (): string | null => {
    const priceFrom: number = cleanObject.price?.[0] ?? 0;
    const priceTo: number = cleanObject.price?.[1];

    if ((priceTo === undefined || priceTo === null) && priceFrom === 0) {
      return "";
    }

    if (priceTo !== undefined && priceTo !== null) {
      return `Цена: ${formatPrice(priceFrom)} ₽ - ${formatPrice(priceTo)} ₽`;
    }

    return `Цена: ${formatPrice(priceFrom)} ₽`;
  };

  return {
    ...(cleanObject.published ? { published: "Размещен" } : {}),
    ...(cleanObject.draft ? { draft: "Черновик" } : {}),
    ...(cleanObject.error ? { error: "Ошибка" } : {}),
    ...(cleanObject.price && needAddPrice && !!getPrice() ? { price: getPrice() } : {}),
    ...(cleanObject.date ? {
      date: `Обновлено: ${date?.[0]?.format("DD.MM.YYYY")} - ${date?.[1]?.format("DD.MM.YYYY")}`,
    } : {}),
    ...(Object.keys(supplierCategories)?.length ? { ...supplierCategories } : {}),
    ...(Object.keys(categoriesBK)?.length ? { ...categoriesBK } : {}),
  };
};
